<mat-card class="dashboard-card">
  <div class="dashboard-header">
    <mat-icon class="dashboard-icon">share</mat-icon>
    <span class="dashboard-title">Shared Studies Dashboard</span>
    <span class="dashboard-subtitle" *ngIf="totalShares > 0">
      {{ totalShares }} share{{ totalShares === 1 ? '' : 's' }} across {{ facilityGroups.length }} facilit{{ facilityGroups.length === 1 ? 'y' : 'ies' }}
    </span>
  </div>

  <div *ngIf="totalShares === 0" class="dashboard-empty">
    <mat-icon class="empty-icon">outbox</mat-icon>
    <span>No studies have been shared yet.</span>
  </div>

  <div class="facility-groups" *ngIf="facilityGroups.length > 0">
    <div *ngFor="let group of facilityGroups" class="facility-group">

      <!-- Group header -->
      <button class="group-header" (click)="toggleGroup(group)" [attr.aria-expanded]="group.expanded">
        <mat-icon class="group-chevron" [class.rotated]="group.expanded">chevron_right</mat-icon>
        <span class="group-facility">{{ group.facilityId }}</span>
        <span class="group-counts">
          <span class="count-chip active-chip" *ngIf="activeCount(group) > 0">
            {{ activeCount(group) }} active
          </span>
          <span class="count-chip pending-chip" *ngIf="pendingCount(group) > 0">
            {{ pendingCount(group) }} re-request{{ pendingCount(group) === 1 ? '' : 's' }}
          </span>
          <span class="count-total">{{ group.shares.length }} total</span>
        </span>
      </button>

      <!-- Share rows -->
      <div class="group-rows" *ngIf="group.expanded">
        <div *ngFor="let share of group.shares" class="share-row">
          <div class="share-row-left">
            <span class="share-uid" [title]="share.study_instance_uid">
              {{ share.study_instance_uid | slice:0:20 }}…
            </span>
            <span class="share-date">Sent {{ formatSharedAt(share) }}</span>
          </div>
          <div class="share-row-right">
            <app-study-share-status-badge [share]="share"></app-study-share-status-badge>
            <button mat-icon-button
                    class="view-button"
                    (click)="onViewStudy(share)"
                    [title]="'View study ' + share.study_instance_uid">
              <mat-icon>visibility</mat-icon>
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>
</mat-card>
